import styled from '@emotion/styled'
import { StyledButton } from '../../buttons/Button/Button.styled'
import { IconChevronRight } from '../../icons/IconChevronRight/IconChevronRight'
import { ePaperLogo } from '../../logos/ePaperLogo/ePaperLogo'
import { breakpoint } from '../../__styling'
import { calcRem } from '../../__styling/style-functions/calc-rem'
//top heading stuff
export const StyledEPaperHeadingWrapper = styled('h1')({
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    marginBottom: 0,
})
export const StyledEPaperHeadingToday = styled('span')(({ theme }) => ({
    fontFamily: theme.fonts.serif,
    fontWeight: 400,
    marginRight: calcRem(12),
}))
export const StyledEPaperHeadingEpaper = styled('span')(({ theme }) => ({
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 550,
    fontSize: calcRem(30),
    marginLeft: calcRem(4),
}))
export const StyledEPaperLogo = styled(ePaperLogo)({
    width: calcRem(10),
    height: calcRem(10),
    display: 'block',
})
//image sizes for different breakpoints
const desktop = require('./assets/epaper-desktop.jpg')
//const tablet = require('./assets/epaperlead.png') might not need this one?
const mobile = require('./assets/epaper-mobile.png')
//main banner stuff
export const StyledEPaperBanner = styled('div')(({ theme }) => ({
    height: '615px',
    background: `url('${mobile}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    overflow: 'clip',
    marginBottom: theme.margins.lg,
    paddingTop: calcRem(35),
    [breakpoint('xxs')]: {
        display: 'block',
        height: '325px',
        background: `url('${desktop}')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingTop: calcRem(57),
        paddingLeft: calcRem(30),
    },
}))
export const StyledEPaperBannerWrapper = styled('div')({
    maxHeight: '325px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    [breakpoint('xxs')]: {
        display: 'block',
    },
})
export const StyledEPaperDateTime = styled('h2')({
    fontSize: '8vw',
    margin: '0',
    [breakpoint('xxs')]: {
        fontSize: calcRem(40),
    },
})
export const StyledEPaperSubheading = styled('div')({
    fontSize: '7vw',
    fontWeight: 'normal',
    margin: '0',
    marginTop: calcRem(4),
    marginBottom: '50px',
    [breakpoint('xxs')]: {
        marginTop: calcRem(6),
        marginBottom: 0,
        fontSize: calcRem(28),
    },
})
//button stuff
export const StyledEPaperButton = styled(StyledButton)({
    textTransform: 'none',
    width: '85%',
    height: '70px',
    fontSize: calcRem(28),
    marginTop: calcRem(300),
    position: 'absolute',
    bottom: '20px',
    [breakpoint('xxs')]: {
        position: 'static',
        marginTop: calcRem(30),
        fontSize: calcRem(28),
        width: calcRem(230),
    },
})
export const StyledEPaperChevon = styled(IconChevronRight)({
    marginLeft: calcRem(17),
    width: calcRem(15),
    height: calcRem(20),
    color: 'inherit',
    fill: 'currentColor',
    transform: 'translateY(2px)', // fix alignment issue
    display: 'inline',
})
//paper images for banner, this is going to change a lot when i get the extra graphic assets
export const StyledEPaperCoverLeft = styled('img')({
    right: '60%',
    top: '190px',
    height: '280px',
    position: 'absolute',
    transform: 'rotate(-10deg) translate(50%, 0)',
    userSelect: 'none',
    [breakpoint('xxs')]: {
        right: '-115px',
        top: '105px',
        height: '300px',
        transform: 'rotate(-20deg)',
    },
    [breakpoint('xs')]: {
        right: '-115px',
        top: '60px',
        height: '535px',
        transform: 'rotate(-20deg)',
    },
    [breakpoint('md')]: {
        right: '200px',
        top: '50px',
        height: '400px',
    },
})
export const StyledEPaperCoverRight = styled('img')({
    right: '35%',
    top: '200px',
    height: '250px',
    position: 'absolute',
    transform: 'rotate(5deg) translate(50%, 0)',
    userSelect: 'none',
    [breakpoint('xxs')]: {
        right: '-100px',
        top: '175px',
        height: '215px',
        transform: 'rotate(-5deg)',
    },
    [breakpoint('xs')]: {
        right: '-110px',
        top: '125px',
        height: '500px',
        transform: 'rotate(-5deg)',
    },
    [breakpoint('md')]: {
        right: '50px',
        top: '100px',
        height: '400px',
    },
})
